import { createRouter, createWebHistory } from 'vue-router'
import { HOME_PATH } from '@/components/layout/utils/navMenu'
import {
  isPortalTabSwitch,
  shouldPreserveScrollOnRouteChange,
  shouldResetPortalPageScroll
} from '@/components/portal/common/utils/portalScrollPreserve'
import { LOCALE_PREFIX_PATTERN, stripLocalePrefix } from '@/components/portal/common/utils/localePath'
import store from '@/store'

const layoutPage = () => import('@/views/SiteLayout.vue')
const homePage = () => import('@/components/home/HomePage.vue')
const portalPage = () => import('@/components/portal/PortalPage.vue')
const productDetailPage = () => import('@/components/modules/products/detail/ProductDetailPage.vue')
const productCatalogPage = () => import('@/components/modules/products/catalog/ProductCatalogPage.vue')
const searchResultsPage = () => import('@/components/modules/search/SearchResultsPage.vue')

const routes = [
  {
    path: `/:localePrefix(${LOCALE_PREFIX_PATTERN})?`,
    component: layoutPage,
    children: [
      { path: '', name: 'Home', component: homePage, meta: { title: '首页', isHome: true } },
      { path: 'products/detail/:id', name: 'ProductDetail', component: productDetailPage, meta: { title: '产品详情' } },
      { path: 'products/catalog/:id?', name: 'ProductCatalogBackup', component: productCatalogPage, meta: { title: '产品目录（备份）' } },
      { path: 'search', name: 'Search', component: searchResultsPage, meta: { title: '搜索' } },
      { path: ':pathMatch(.*)*', name: 'Portal', component: portalPage }
    ]
  }
]

function routeContentPath(route) {
  if (route?.meta?.isHome || route?.name === 'Home') return HOME_PATH
  return stripLocalePrefix(route?.path)
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition

    const menus = store.state.nav?.rawMenus || []
    const locale = store.state.locale?.current
    const toForScroll = { ...to, path: routeContentPath(to) }
    const fromForScroll = { ...from, path: routeContentPath(from) }
    if (isPortalTabSwitch(toForScroll, fromForScroll, menus, locale)) {
      return false
    }
    if (shouldPreserveScrollOnRouteChange(toForScroll, fromForScroll, menus)) {
      return false
    }
    if (shouldResetPortalPageScroll(toForScroll, fromForScroll, menus, locale)) {
      return false
    }

    return { left: 0, top: 0 }
  }
})

export default router
